const googleAPIKey = 'AIzaSyDAvJzEiwtsysQIRsOAIr62MyJRDMTVH3M';
export { googleAPIKey };



// WEBPACK FOOTER //
// ./src/keys.js